/** Shared live-update timings for the seller portal (React Query). */

/** How long cached data is treated as fresh (avoids redundant refetches). */
export const LIVE_STALE_MS = 15_000;
export const LIVE_GC_MS = 10 * 60_000;

export const LIVE_POLL = {
  /** Active chat thread */
  CHAT: 5_000,
  /** Lists on the current page (orders, offers, products, …) */
  LIST: 12_000,
  /** Sidebar badges, conversation list */
  BADGE: 15_000,
  /** Dashboard / stats cards */
  STATS: 20_000,
  /** Rarely changing settings */
  SETTINGS: 60_000,
  /** Notification list */
  NOTIFICATIONS: 30_000,
  /** Unread summary */
  NOTIFICATIONS_SUMMARY: 20_000,
} as const;

export function livePollInterval(ms: number): number | false {
  if (typeof document !== 'undefined' && document.hidden) {
    return false;
  }
  return ms;
}
